import React from 'react'
import { Link } from 'react-router-dom'
import mac from "./img/oudiphone.png"
import web from "./img/oudiweb.png"
import Image from "../../../../Components/Image"

function Oudi() {
    return (
        <div className=" animated fadeInIn">
            <div id="work_content">
                <div className="work_title">Oudi</div>
                <div className="work_type">Mobile Application</div>
                <div className="process_title">
                    Overview
                </div>
                <div className="process_text">
                    <p>
                    Express Yourself With Oudi… Share Your Opinions And Views In The Most Simplest Expressive Way.
                    </p>
                    <p>
                        With Oudi you can Create circles with friends &amp; unleash the excitement.. Express yourself like never before with voice and image posts.<br/>
                        Oudi allows you to create substantial engagements with your friends in the most straightforward ways.
                    </p>

                    <a href='https://apps.apple.com/gb/app/oudi/id1571999846' className="work_btn" target='_blank'>Get on the app store</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href='https://oudi.app'className="work_btn"  target='_blank'>Visit Website</a>
                </div>
            </div>
            <div id="images">
                <Image src={mac} />
            </div>
            <div id="work_content">
                <div className="process_title">
                    Resources
                </div>
                <div className="process_text">

                    <p>
                        <div className="dev_title">Front End</div>
                        <div className="dev_info"> Mobile : React-native, Expo, SASS, HookState.<br /> Website : React, SASS</div>
                    </p>
                    <p>
                        <div className="dev_title">Back End</div>
                        <div className="dev_info">NodeJs, Express, Firebase, Cloud functions</div>
                    </p>
                </div>
            </div>
            <div id="images">
                <Image src={web} />
            </div>
        </div>
    )
}

export default Oudi